export default "__VITE_ASSET__CtBbUDRh__"